"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("firebase/auth");
const globals_1 = require("../../infra/globals");
const router_1 = require("../../routing/router");
const game_record_1 = require("../../models/game_record");
const game_event_1 = require("../../models/game_event");
class NewGameRecordView extends HTMLElement {
    static tag = "new-game-record-view";
    currentUser = null;
    constructor() {
        super();
        globals_1.setup.initAuth();
    }
    async connectedCallback() {
        (0, auth_1.onAuthStateChanged)(globals_1.setup.auth, (user) => {
            if (user) {
                this.currentUser = user;
                this.setNewGameRecordForm();
            }
            else
                globals_1.router.manualRouting(router_1.RouteEnum.admin);
        });
    }
    setNewGameRecordForm = () => {
        this.innerHTML = `
      <form>
        <fieldset>
          <label for="blackRef">ID Preto</label>
          <input required type="text" name="blackRef"/>
        </fieldset>

        <fieldset>
          <label for="whiteRef">ID Branco</label>
          <input required type="text" name="whiteRef"/>
        </fieldset>

        <fieldset>
          <label for="whoWins">Quem ganhou?</label>
          <select name="whoWins">
            <option selected value="${game_record_1.Color.Black}">${game_record_1.Color.Black}</option>
            <option value="${game_record_1.Color.White}">${game_record_1.Color.Black}</option>
          </select>

          <label for="resign">Por desistência ou por pontos?</label>
          <select name="resign">
            <option selected value="resign">Desistência</option>
            <option value="points">Pontos</option>
          </select>
          
          <div id="difference"></div>
        </fieldset>
        
        <fieldset>
          <label for="sgf">SGF</label>
          <input type="file" name="sgf"/>
        </fieldset>

        <fieldset>
          <label for="date">Data da Partida</label>
          <input type="date" name="date"/>
        </fieldset>

        <fieldset id="game-event">
          <label for="game-event-type">Tipo de Evento</label>
          <select name="game-event-type">
            <option value="${game_event_1.GameEventTypes.online}">${game_event_1.GameEventTypes.online}</option>
            <option value="${game_event_1.GameEventTypes.live}">${game_event_1.GameEventTypes.live}</option>
            <option value="${game_event_1.GameEventTypes.tournament}">${game_event_1.GameEventTypes.tournament}</option>
            <option value="${game_event_1.GameEventTypes.league}">${game_event_1.GameEventTypes.league}</option>
          </select>

          <div id="game-event-id"></div>
        </fieldset>

        <fieldset>
        </fieldset>

        <button type="submit">Adicionar Partida</buton>
      </form>
    `;
        const sgfInput = this.querySelector("input[name=sgf]");
        sgfInput.onchange = this.sgfOnChange;
        const resignSelect = this.querySelector("select[name=resign]");
        resignSelect.onchange = this.resignSelectOnchange;
        const gameEventTypeSelect = this.querySelector("select[name=game-event-type]");
        gameEventTypeSelect.onchange = this.gameEventTypeSelectOnChange;
        const form = this.querySelector("form");
        form.onsubmit = this.onSubmit;
    };
    get difference() {
        const diffInput = this.querySelector("input[name=difference]");
        if (diffInput)
            return diffInput.valueAsNumber;
        else
            return;
    }
    resignSelectOnchange = () => {
        const resignSelect = this.querySelector("select[name=resign]");
        const diffDiv = this.querySelector("div#difference");
        if (resignSelect.value === "points")
            diffDiv.innerHTML = `
        <input type="number" name="difference" placeholder="diferença"/>
      `;
        else
            diffDiv.innerHTML = "";
    };
    get gameEventRef() {
        const gameEventTypeSelect = this.querySelector("select[name=game-event-type]");
        if (gameEventTypeSelect.value === game_event_1.GameEventTypes.online ||
            gameEventTypeSelect.value === game_event_1.GameEventTypes.league)
            return gameEventTypeSelect.value;
        else {
            const gameEventIdInput = this.querySelector("input[name=game-event-id]");
            return gameEventIdInput.value;
        }
    }
    gameEventTypeSelectOnChange = () => {
        const gameEventTypeSelect = this.querySelector("select[name=game-event-type]");
        const gameEventIdDiv = this.querySelector("div#game-event-id");
        if (gameEventTypeSelect.value === game_event_1.GameEventTypes.tournament ||
            gameEventTypeSelect.value === game_event_1.GameEventTypes.league)
            gameEventIdDiv.innerHTML = `
        <input 
          type="text"
          name="game-event-id"
          placeholder="ID do Torneio ou Liga"/>
      `;
        else
            gameEventIdDiv.innerHTML = "";
    };
    get blackRef() {
        const blackRefInput = this.querySelector("input[name=blackRef]");
        return blackRefInput.value;
    }
    get whiteRef() {
        const whiteRefInput = this.querySelector("input[name=whiteRef]");
        return whiteRefInput.value;
    }
    get date() {
        const dateInput = this.querySelector("input[name=date]");
        return dateInput.valueAsDate?.getTime();
    }
    sgf = "";
    sgfOnChange = () => {
        const sgfInput = this.querySelector("input[name=sgf]");
        const file = sgfInput.files?.item(0);
        const fileReader = new FileReader();
        fileReader.onload = () => {
            if (file.size < 500000)
                this.sgf = fileReader.result;
        };
        if (file)
            fileReader.readAsText(file);
    };
    get whoWins() {
        const colorSelect = this.querySelector("select[name=whoWins]");
        return (0, game_record_1.colorFromString)(colorSelect.value);
    }
    validate = () => {
        if (this.blackRef === this.whiteRef)
            return false;
        else
            return true;
    };
    onSubmit = async (e) => {
        e.preventDefault();
        if (this.validate()) {
            const gameRecord = {
                blackRef: this.blackRef,
                whiteRef: this.whiteRef,
                date: this.date,
                result: {
                    whoWins: this.whoWins,
                    difference: this.difference,
                },
                sgf: this.sgf,
                gameEventRef: this.gameEventRef,
                author: {
                    uid: this.currentUser?.uid,
                    name: this.currentUser?.displayName,
                    email: this.currentUser?.email,
                },
            };
            const userIdToken = await this.currentUser?.getIdToken();
            const res = await fetch(`${globals_1.apiUrl}${router_1.RouteEnum.gameRecords}/novo`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userIdToken}`,
                },
                body: JSON.stringify(gameRecord),
            });
            const json = await res.json();
            const gameRecordFromServer = json["data"]["gameRecord"];
            if (gameRecordFromServer)
                this.innerHTML += `
          <div id="return-msg">
            <p>Partida adicionada com sucesso!</p>
            <p>
              Para visualizá-la, clique 
              <route-link 
                href="${router_1.RouteEnum.gameRecords}/${gameRecordFromServer.firebaseRef}">
                  aqui
              </route-link>.
            </p>
          </div>
        `;
            else
                this.innerHTML += `
          <div id="return-msg">
            <p>Não foi possível adicionar tal partida.</p>
          </div>
        `;
        }
    };
}
exports.default = NewGameRecordView;
//# sourceMappingURL=data:application/json;base64,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